// extracted by mini-css-extract-plugin
export default {"root":"AdsSection_root_a873T","heading":"AdsSection_heading_qY0NP","ads":"AdsSection_ads_kX_S5"};